import instance from '../utils/request.js'
// 新闻资讯列表
export function getNewsList(data){
    return instance({
        url:'/api/longxie/news/findByPage',
        method:'post',
        data
    })
}
// 新闻资讯详情
export function getNewsDetil(data){
    return instance({
        url:'/api/longxie/news/findById',
        method:'post',
        data
    })
}


// WEBPACK FOOTER //
// ./src/api/news.js